
  import * as ipxStaticRuntime$_8Rxyxg0EigjbMXY7MSioG3CZ42VZIb1R_45x_x6qwDRPs from '/opt/buildhome/repo/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@9.1.2_db0@0.3.4_ioredis@5.8.2_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [
    "cms-assets.americanbookcompany.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ]
},
    providers: {
        ['ipxStatic']: { provider: ipxStaticRuntime$_8Rxyxg0EigjbMXY7MSioG3CZ42VZIb1R_45x_x6qwDRPs, defaults: {} }
    }
  }
